export enum JackpotTypeEnum {
  GOLD = "gold",
  SILVER = "silver",
}

export enum SpecialBettingsColorEnum {
  RED = "R",
  BLACK = "B",
}

export enum SpecialBettingsParityEnum {
  EVEN = "EVEN",
  ODD = "ODD",
}

export enum RequestStatus {
  REJECTED = "rejected",
  FULFILLED = "fulfilled",
}

export enum StatusCode {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  BETTING_DISABLED = 423,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
  OUT_OF_MONEY = 1000,
  BET_FAILED = 1001,
}

export enum BetTypeEnum {
  NUMBER = 1,
  COLOR = 2,
  PARITY = 3,
}

export enum CreateTicketCodes {
  SUCCESS = 1,
  OUT_OF_MONEY = 2,
  ERROR = 3,
  MAX_STAKE_REACHED = 4,
  BETTING_DISABLED = 5,
}

export enum ActiveTabEnum {
  PLAY,
  DRAW,
  NONE = -1,
}

export enum AudioEnum {
  NO_EFFECT,
  BACKGROUND_BET,
  BACKGROUND_DRAW,
  EFFECT_DELETE,
  EFFECT_DRAW,
  EFFECT_PLAY,
  EFFECT_MODAL_OK,
  EFFECT_MODAL_INFO,
  EFFECT_UNDO,
  EFFECT_MULTIPLIER,
  EFFECT_FULL_STAKE,
  EFFECT_COUNTDOWN,
  EFFECT_CAROUSEL,
  EFFECT_BET_LOST,
  EFFECT_BET_WON,
  EFFECT_ROULETTE_TICK,
}

export enum GameTypeEnum {
  NONE = -1,
  ONLINE,
  PANEL,
  PRESENTATION,
}

export enum AvailableLanguagesEnum {
  ENG = "ENG",
  SRSR = "SR-SR",
  SRBA = "SR-BA",
  MNE = "MNE",
  CRO = "CRO",
}

export enum TabEnum {
  BETTING,
  DRAW,
}
